module.exports = __webpack_public_path__ + "media/images/header-logo-9ccd1e4433716cd31b8a50b307c3affb.png";